import { style } from '@angular/animations';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-authorized-error',
  templateUrl: './authorized-error.component.html',
  styleUrls: ['./authorized-error.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthorizedErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    const elems = document.querySelectorAll('kendo-menu');
    let index = 0, length = elems.length;
    for (index; index < length; index++) {
      elems[index].classList.add('hideelement');
    }
  }

}
